function equalsFactory(target) {
  function equals({ path, resolve }) {
    if (!resolve.isTag(target, 'state', 'props', 'module')) {
      throw new Error(
        'Cerebral operator.equals: You have to use the STATE, PROPS or MODULE tag as first argument'
      )
    }

    const targetValue = resolve.value(target)

    return path[targetValue] ? path[targetValue]() : path.otherwise()
  }

  equals.displayName = `operator.equals(${String(target)})`

  return equals
}

export default equalsFactory
